// import React from "react";
import { Button, Col, Input, Row, Select, Tooltip, Form, Typography, Modal, message, Card, Empty, Space, Checkbox, TimePicker, Switch} from "antd";
import React, { useState, useEffect } from "react";
import axiosClient from "../../Authentication/ApiCall";
import authService from "../../Authentication/authService";
import ClipLoader from "react-spinners/ClipLoader";
import { EditOutlined, DeleteOutlined, PlusOutlined, UserOutlined, CheckOutlined, CloseOutlined  } from "@ant-design/icons";
import moment from "moment";
import _, { } from "lodash";
import dayjs from 'dayjs';

const MailConfiguration = () => {
  const { Text } = Typography;
  const [modal, setModal] = useState(false);
  const [form] = Form.useForm();
  const [editform] = Form.useForm();
  const [AddRefresh, setAddRefresh] = useState(1);
  const [Pageload, setPageload] = useState(false);
  const [tabledata, settabledata] = useState([]);
  const [editrecord, seteditrecord] = useState(null);
  const [editModal, seteditModal] = useState(false);
  const [Stores, setStores] = useState([]);
  const [TypeList, setTypeList] = useState([
    { label: "Daily", value: 1 },
    { label: "Weekly", value: 2 },
    { label: "Monthly", value: 3 },
  ]);
  const { Option } = Select;

  const onclickmodal = () => {
    setModal(true);
    form.resetFields();
  };

  const handlecreateeventclose = () => {
    setModal(false);
    form.resetFields();
  };

  //onfish of mail configuration
  const onFinish = (values) => {
    axiosClient
      .post("/mailconfig/addmailconfigurationdetails ", {
        storeId: values.storeId,       
        schedulertype: values.schedulertype,
        isonline: values.isonline,
        time: moment(new Date(values.time)).format("HH:mm"),
        userdetails: values.userdetails.map((item) => item.email),
      })
      .then((response) => {
        if (response.data.issuccess === true) {
          message.success(response.data.data);
          setAddRefresh(AddRefresh + 1);
          setModal(false);
          form.resetFields();
        }
      })
      .catch((err) => {
        setModal(false);
        setPageload(false);
        if (err.status === 0) {
          message.error("Server error");
        } else {
          message.error(err.msg);
        }
      });
  };

  const onEditRecord = (items) => {
    seteditModal(true);
    editform.setFieldsValue({
      storeName: items.storeName,    
      userdetails: items.userdetails.map(email => ({ email })),
      schedulertype: items.schedulertype,
      isonline: items.isonline,
      isactive: items.isactive,
      time: dayjs(items.time, 'HH:mm'),      
    });
  };

  const handleclose = () => { seteditModal(false); };

  const onFinishedit = (values) => {
    axiosClient
      .put("mailconfig/editmailconfigurationdetails", {
        id: editrecord.id,
        storeId: editrecord.storeId,       
        schedulertype: values.schedulertype,
        isonline: values.isonline,
        isactive: values.isactive,
        time: moment(new Date(values.time)).format("HH:mm"),
        userdetails: values.userdetails.map((item) => item.email),
      })
      .then((response) => {
        if (response.status === 200) {
          // setPageload(false)
          seteditModal(false);
          setAddRefresh(AddRefresh + 1);
          message.success(response.data.msg);
        } else {
          setPageload(false);
          message.error(response.data.msg);
        }
      })
      .catch((err) => {
        seteditModal(false);
        // setPageload(false)
        if (err.status === 0) {
          message.error("Server error");
        } else {
          message.error(err.msg);
        }
      });

    form.resetFields();
  };

  //Delete Record
  const onDeleteRecord = (items) => {
    Modal.confirm({
      title: (
        <div>
          <h3>Confirm Delete?</h3>
          <h4>
            {" "}
          </h4>  All the mail configuration will be deleted
        </div>
      ),
      okText: "Confirm",
      okType: "danger",
      onOk: () => {
        axiosClient
          .get("/mailconfig/deletemailconfigurationdetails?id=" + items.id)
          .then((response) => {
            if (response.data.issuccess === true) {
              message.success(response.data.msg);
              setAddRefresh(AddRefresh + 1);
            } else {
              setAddRefresh(AddRefresh + 1);
            }
          })
          .catch((err) => {
            if (err.status === 0) {
              message.error("Server error");
              setAddRefresh(AddRefresh + 1);
            } else {
              message.error(err.msg);
            }
          });
      },
    });
    form.resetFields();
  };

  const oncancelofform = () => {
    setModal(false);
    form.resetFields();
  };

  const disabledTime = () => ({
    disabledHours: () => {
      return [...Array(6).keys()]; 
    },
    disabledMinutes: () => {
      return [];
    },
    disabledSeconds: () => {
      return [];
    },
  });

  useEffect(() => {
    const fetchData1 = () => {
      axiosClient
        .get("/mailconfig/getmailconfigurationdetails")
        .then((response) => {
          if (response && response.data && response.data.data) {
            const flattenedData = response.data.data.flat();
            settabledata(flattenedData);
          }
        })
        .catch((err) => {
          if (err.status === 0) {
            message.error("Server error");
          } else {
            message.error(err.msg);
          }
        });
    };

    fetchData1();
  }, [AddRefresh]);

  useEffect(() => {
    axiosClient
      .get("/flooronboard/getstoredetails")
      .then((response) => {
        if (response.data.issuccess === true) {
          setStores(response.data.data);
        }
      })
      .catch((err) => {
        if (err.status === 0) {
          message.error("Server error");
        } else {
          message.error(err.msg);
        }
      });
  }, []);

  return (
    <>
      <div
        className="report-content"
        style={{
          // height: "120px",
          backgroundColor: "#000816",
          width: "100%",
          // marginLeft: "9px",
          margin: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {/* First Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginLeft: "3%",
            padding: "10px",
            marginTop: "10px",
          }}
        >
          <p
            style={{
              color: "white",
              fontSize: "21px",
              fontFamily: "revert-layer",
            }}
          >
            Mail Configuration
          </p>
          <div style={{ display: "flex", marginRight: "3%" }}>
            <Button
              style={{ userSelect: "none" }}
              className="adduser"
              onClick={onclickmodal}
            >
              + New
            </Button>
          </div>
        </div>
      </div>

      {/* //adding mail modal */}
      <Modal
        className="onsubmitrtspmodal"
        destroyOnClose
        centered
        open={modal}
        width={800}
        onCancel={oncancelofform}
        title={
          <>
            <Row align={"middle"} justify={"center"}>
              <Col>
                <Text className="Modal-Header">Mail Configuration</Text>
              </Col>
            </Row>
          </>
        }
        footer={
          <>
            <Row justify={"space-around"}>
              <Col>
                {authService.getCurrentUserReadOnly() ? (
                  <Tooltip title="you need permission to submit">
                    <Button type="primary" block disabled>
                      Submit
                    </Button>
                  </Tooltip>
                ) : (
                  <Button
                    className="primary-button"
                    form="submitAdduserForm"
                    type="primary"
                    block
                    htmlType="submit"
                  >
                    Submit
                  </Button>
                )}
              </Col>
              <Col>
                <Button onClick={() => handlecreateeventclose()}>Cancel</Button>
              </Col>
            </Row>
          </>
        }
      >
        <Row>
        <Col span={24}>
      
            <div style={{ marginTop: "10px" }}>
              <Form
                id="submitAdduserForm"
                // layout="vertical"
                form={form}
                name="basic"
                onFinish={onFinish}
                autoComplete={"off"}
                style={{ padding: "7px" }}      
                initialValues={{
                  isonline: false,
                }}          
              >

                <Form.Item
                  labelCol={{
                    span: 9,
                  }}
                  wrapperCol={{
                    span: 14,
                  }}
                  label="Store"
                  name="storeId"
                  rules={[
                    {
                      required: true,
                      message: "Please Select Store!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: 200 }}
                    placeholder="Select a store"
                  >
                    {Stores.map((store) => (
                      <Option key={store.id} value={store.id}>
                        {store.storeName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  labelCol={{
                    span: 9,
                  }}
                  wrapperCol={{
                    span: 14,
                  }}
                  label="Select type"
                  name="schedulertype"
                  rules={[
                    {
                      required: true,
                      message: "Please select any type!",
                    },
                  ]}
                >
                  <Checkbox.Group
                    name="checkbox"
                    className="subtype"
                    options={TypeList}
                  ></Checkbox.Group>
                </Form.Item>
                <Form.Item
                  labelCol={{
                    span: 9,
                  }}
                  wrapperCol={{
                    span: 14,
                  }}
                  label="Is Online"
                  name="isonline"
                  valuePropName="checked"
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                >
                  <Switch
                    checkedChildren={<CheckOutlined />}
                    unCheckedChildren={<CloseOutlined />}
                    defaultChecked
                  />
                 
                </Form.Item>
                <Form.Item
                   labelCol={{
                    span: 9,
                  }}
                  wrapperCol={{
                    span: 14,
                  }}
                  label="Select Time (hour)"
                  name="time"
                  rules={[{ required: true, message: 'Please select a time!' }]}
                >
                  <TimePicker
                    format="HH:mm"  
                    use12Hours={false}      
                    //disabledTime={disabledTime}              
                  />
                </Form.Item>
                <Form.List   
              
                  name="userdetails" 
                  initialValue={['']} 
                  rules={[
                    {
                      validator: async (_, texts) => {
                        if (!texts || texts.length < 1) {
                          return Promise.reject(new Error('At least one text field must be filled'));
                        }
                      },
                    },
                  ]}
                >
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name }) => (
                       
                        <div key={key} style={{ marginBottom: 16, alignItems: 'center' }}>
                          <Form.Item
                            label="Enter Mail"
                            labelCol={{ span: 9 }}
                            wrapperCol={{ span: 14 }}
                            name={[name, 'email']}
                            rules={[{ required: true, message: 'Please enter the mail!' }]}
                            style={{ marginBottom: 0 }}
                          >
                            <Input placeholder="Enter the mail" type="email" style={{ width: '50%' }} />
                          </Form.Item>
                          {/* Move the buttons below the input field */}
                          <Space style={{ marginLeft: 300 }}>
                         
                          {fields.length > 1 && (
                            <Button
                              type="danger"
                              onClick={() => remove(name)}
                              icon={<DeleteOutlined />}
                            />
                          )}
                          <Button
                            type="dashed"
                            onClick={() => add()}
                            icon={<PlusOutlined />}
                          />
                        </Space>

                        </div>
                      ))}                     
                    </>
                  )}
                </Form.List>
              </Form>
            </div>
          </Col>
        </Row>
      </Modal>

      {/* //loading modal */}
      <Modal
        className="LoadinModal"
        open={Pageload}
        style={{ background: "none", textAlign: "center" }}
        footer={false}
        closable={false}
        centered
      >
        <ClipLoader
          color="#23234d"
          loading={Pageload}
          cssOverride={{
            display: "block",
            margin: "0 auto",

            borderWidth: "5px",
            marginBottom: "10px",
          }}
          size={100}
          aria-label="Loading Spinner"
          data-testid="loader"
          title="Loading..."
        />
        <Text style={{ color: "white", fontSize: "1.2em" }}>Loading ...</Text>
      </Modal>

      {/* //display the store data */}
      <Row
        gutter={[10, 10]}
        align={"middle"}
        justify={"center"}
        style={{ marginTop: "18px" }}
      >
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 24, offset: 0 }}
          md={{ span: 24, offset: 0 }}
          lg={{ span: 24, offset: 0 }}
          xl={{ span: 23, offset: 0 }}
          xxl={{ span: 23, offset: 0 }}
        >
          {tabledata.length > 0 ? (
            <Row gutter={[6, 6]}>
              {tabledata.map((items) => (
                <Col
                  xs={{ span: 14, offset: 0 }}
                  sm={{ span: 14, offset: 0 }}
                  md={{ span: 14, offset: 0 }}
                  lg={{ span: 14, offset: 0 }}
                  xl={{ span: 4, offset: 0 }}
                  xxl={{ span: 4, offset: 0 }}
                >
                  <Card
                    hoverable
                    title={items.storeName + " - " + items.time }
                    styles={{
                      title: { textAlign: "center" },
                      body: { padding: 0 },
                      height: "300px",
                    }}
                  >
                    <div
                      className="border-line"
                      style={{ borderBottom: "1px solid #d9d0d0" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "0 16px",
                        }}
                      >
                        <Button
                          type="text"
                          icon={<EditOutlined />}
                          onClick={() => {
                            onEditRecord(items);
                            seteditrecord(items);
                          }}
                        />

                        <Button
                          type="text"
                          icon={<DeleteOutlined style={{ color: "red" }} />}
                          // onClick={handleDelete}
                          onClick={() => {
                            onDeleteRecord(items);
                          }}
                        />
                      </div>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "230px",
              }}
            >
              <Empty />
            </div>
          )}
        </Col>
      </Row>

      <Modal
        title="Edit Record"
        onCancel={() => seteditModal(false)}
        centered
        open={editModal}
        footer={
          <>
            <Row justify={"space-around"}>
              <Col>
                {authService.getCurrentUserReadOnly() ? (
                  <Tooltip title="you need permission to submit">
                    <Button type="primary" block disabled>
                      Submit
                    </Button>
                  </Tooltip>
                ) : (
                  <Button
                    className="primary-button"
                    form="submiteditform"
                    type="primary"
                    block
                    htmlType="submit"
                  >
                    Submit
                  </Button>
                )}
              </Col>
              <Col>
                <Button onClick={() => handleclose()}>Cancel</Button>
              </Col>
            </Row>
          </>
        }
      // onCancel={handleCancel}
      >
        <Form
          form={editform}
          id="submiteditform"
          name="basic"
          onFinish={onFinishedit}
          autoComplete={"off"}
        >
          <Form.Item
            label="Store Name"
            name="storeName"
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 9,
            }}
            rules={[
              {
                required: false,
                message: "Please enter your Store Name!",
              },
            ]}
          >
            <Input
              placeholder="Store Name"
              prefix={<UserOutlined className="site-form-item-icon" />}
              disabled={true}
            />
          </Form.Item>

          <Form.Item
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 14,
            }}
            label="Select type"
            name="schedulertype"
            rules={[
              {
                required: true,
                message: "Please select any type!",
              },
            ]}
          >
            <Checkbox.Group
              name="checkbox"
              className="subtype"
              options={TypeList}
            ></Checkbox.Group>
          </Form.Item>
          <Form.Item
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 14,
            }}
            label="Is Online"
            name="isonline"    
            valuePropName="checked"     
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              defaultChecked
            />
          </Form.Item>
          <Form.Item
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 14,
            }}
            label="Is Active"
            name="isactive"    
            valuePropName="checked"     
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              defaultChecked
            />
          </Form.Item>
          <Form.Item
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 14,
            }}
            label="Select Time (Hour)"
            name="time"
            rules={[{ required: true, message: 'Please select a time!' }]}
          >
            <TimePicker
              format="HH:mm"
              use12Hours={false}
              //disabledTime={disabledTime}
            />
          </Form.Item>

          <Form.List                 
              name="userdetails" 
              initialValue={['']} 
              rules={[
                {
                  validator: async (_, texts) => {
                    if (!texts || texts.length < 1) {
                      return Promise.reject(new Error('At least one text field must be filled'));
                    }
                  },
                },
              ]}
            >
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name }) => (
                 
                    <div key={key} style={{ marginBottom: 16, alignItems: 'center' }}>
                      <Form.Item
                        label="Enter Mail"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 14 }}
                        name={[name, 'email']}
                        rules={[{ required: true, message: 'Please enter the mail!' }]}
                        style={{ marginBottom: 0 }}
                      >
                        <Input placeholder="Enter the mail" type="email" style={{ width: '50%' }} />
                      </Form.Item>
                      {/* Move the buttons below the input field */}
                      <Space style={{ marginLeft: 300 }}>
                     
                      {fields.length > 1 && (
                        <Button
                          type="danger"
                          onClick={() => remove(name)}
                          icon={<DeleteOutlined />}
                        />
                      )}
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        icon={<PlusOutlined />}
                      />
                    </Space>

                    </div>
                  ))}                     
                </>
              )}
            </Form.List>
        </Form>
      </Modal>
    </>
  );
};
export default MailConfiguration;
